// extracted by mini-css-extract-plugin
export default {"message":"kqtjXCoo","message__title":"KqV3XlFZ","form":"iPMo4vW8"};